export default __webpack_public_path__ + "static/media/systemsettings_phone.0881e057.png";